
import { defineComponent, onBeforeMount, ref } from 'vue';
import axios, { AxiosError } from 'axios';
import { getProgramDetails, updateEmailTemplate } from '@/utils/admin/program_services';
// eslint-disable-next-line
// import router from '@/router';
import { invokeGetUserRole } from '@/utils/admin/master_service';
import { getApi } from '@/utils/ApiCalls';
import { DownloadIcon } from 'vue-feather-icons';
import { downloadLearnerSubmission } from '@/utils/learner_review_service';

export default defineComponent({
  name: 'ProgramDetails',
  components: { DownloadIcon },
  // props: ['query'],
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const programId = ref(props.query.program_id);
    const renderReady = ref();
    const programDetails = ref();
    const emailTemplates = ref();
    const allEmailTemplates = ref();
    const proxyOHR = ref();
    // const programParticipants = ref([]);
    const showUpdate = ref(true);
    const loggedInUserRoles = ref();
    const showScreen = ref(true);
    const showSuccessMessage = ref(false);
    const resMessage = ref();
    const showErrorMessage = ref(false);
    const loggedInUser = ref();
    const getProgram = async () => {
      try {
        renderReady.value = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any = await getProgramDetails(programId.value);
        programDetails.value = res.prog_detail;
        emailTemplates.value = programDetails.value.email_templates;
        console.log('emailTemplates.value', emailTemplates.value);
        const response = await getApi('/email/templates/all');
        allEmailTemplates.value = response.data.body.Items;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        allEmailTemplates.value = allEmailTemplates.value.sort((a: any, b: any) => a.template_name.localeCompare(b.template_name));
        console.log('allemailTemplates.value', allEmailTemplates.value);
        renderReady.value = true;
      } catch (error) {
        console.log(error);
      }
    };

    const downloadExportFile = async (url: string, zipName: string) => {
      await downloadLearnerSubmission(url, zipName);
    };

    const exportTemplates = async () => {
      try {
        renderReady.value = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any = await getApi(`/email/templates/export/${programId.value}`);
        await downloadExportFile(res.data.body.url, res.data.body.zip_name);
        renderReady.value = true;
      } catch (error) {
        renderReady.value = true;
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          resMessage.value = (err.response?.data as { message: string })?.message;
        } else {
          resMessage.value = 'There was a problem in exporting email templates.';
        }
        showErrorMessage.value = true;
        setTimeout(() => {
          showErrorMessage.value = false;
        }, 7000);
      }
    };

    const updateEventTemplateRecord = async () => {
      try {
        console.log('Inside Update Program');
        const emailTempObj = { program_id: programId.value, email_templates: emailTemplates.value };
        console.log('emailTempObj', emailTempObj);
        // programDetails.value.linked_proxy_ohr = proxyOHR.value.split(',');
        // console.log('proxy OHR', programDetails.value.linked_proxy_ohr);
        renderReady.value = false;
        // programDetails.value.linked_proxy_ohr = proxyOHR.value ? proxyOHR.value : [];
        const updateRes = await updateEmailTemplate(emailTempObj);
        await getProgram();
        if (updateRes.data) {
          resMessage.value = updateRes.data.message;
          showSuccessMessage.value = true;
          setTimeout(() => {
            showSuccessMessage.value = false;
          }, 6000);
          renderReady.value = true;
          // router.push({ path: 'programAdministration' });
        }
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          console.log(err.response?.data);
          renderReady.value = true;
          resMessage.value = (err.response?.data as { message: string })?.message;
          showErrorMessage.value = true;
          setTimeout(() => {
            showErrorMessage.value = false;
          }, 6000);
        }
      }
    };
    const changeFunction = (template, event) => {
      // filteredProgramDetails.value = value;
      //   const obj = JSON.parse(name);
      console.log('template', template);
      console.log('event', event);
      console.log('emailTemplates[name] before update', emailTemplates.value[event]);
      emailTemplates.value[event] = template.target.value;
      console.log('emailTemplates[name] after update', emailTemplates.value[event]);
    };
    onBeforeMount(async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const role: any = await invokeGetUserRole('/getUserRole');
      await getProgram();
      loggedInUserRoles.value = role.user_roles;
      loggedInUser.value = role.user_key;
      if (loggedInUserRoles.value.length > 0) {
        if (loggedInUserRoles.value.includes('System Admin') || loggedInUserRoles.value.includes('Program Admin')) {
          showUpdate.value = true;
          showScreen.value = true;
        } else {
          showUpdate.value = false;
          showScreen.value = false;
        }
        if (loggedInUserRoles.value.includes('System Admin View Access')) {
          showScreen.value = true;
          showUpdate.value = false;
        }
      }
    });
    return {
      renderReady,
      programDetails,
      updateEventTemplateRecord,
      showUpdate,
      showScreen,
      showSuccessMessage,
      resMessage,
      loggedInUser,
      proxyOHR,
      emailTemplates,
      allEmailTemplates,
      changeFunction,
      showErrorMessage,
      exportTemplates,
    };
  },
});
